import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
import commonFn from "@/commons/commonFunction";
class ReportControlAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Management";
  controllerName = "merchanttransactioncontrolreports";
  /**
   * @override
   * Tìm kiếm thông tin công ty theo taxcode or Name
   *
   */
  getList(payload) {
    let param = {
      maxResultCount: payload.take || 20,
      filter: payload.Filter || null,
      skipCount: payload.skip || 0,
      sorting: payload.Sort || null,
    };

    let url = this.getAPIUrl() + "/merchants/settlementreport";
    // Build tham số
    let request = {
      url: url,
      data: param,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  /**
   * xuất excel
   * @param {} payload
   */
  async exportDetail(data) {
    let url = this.getAPIUrl() + "/merchant/export";
    let customFilter = commonFn.buildFilterParam(data.filter);
    let req = {
      url: url,
      data: {
        filter: customFilter,
        fromTransactionTime: data.fromTransactionTime,
        toTransactionTime: data.toTransactionTime,
      },
      responseType: "blob",
    };
    var result = await this.postAsync(req);
    const urlResult = window.URL.createObjectURL(new Blob([result]));
    const link = document.createElement("a");
    link.href = urlResult;
    link.setAttribute("download", data.fileName); //or any other extension
    document.body.appendChild(link);
    link.click();
  }
}

export default new ReportControlAPI();
